const naver = window.naver;

var CustomOverlay = function (options) {
  var div = document.createElement("div");
  div.innerHTML = "커스텀오버레이";
  div.style.position = "absolute";
  div.style.left = 0 + "px";
  div.style.top = 0 + "px";
  div.style.width = 120 + "px";
  div.style.height = 30 + "px";
  div.style.lineHieght = 30 + "px";
  div.style.textAlign = "center";
  div.style.backgroundColor = "#fff";
  div.style.border = "2px solid #f00";
  div.className = "customOverlay";
  this._element = options.element ? options.element : div;
  this.setPosition(options.position);
  this.setMap(options.map || null);
};

// CustomOverlay는 OverlayView를 상속받습니다.
CustomOverlay.prototype = new naver.maps.OverlayView();
CustomOverlay.prototype.constructor = CustomOverlay;

CustomOverlay.prototype.onAdd = function () {
  var overlayLayer = this.getPanes().overlayLayer;
  overlayLayer.appendChild(this._element);
};

CustomOverlay.prototype.draw = function () {
  // 지도 객체가 설정되지 않았으면 draw 기능을 하지 않습니다.
  if (!this.getMap()) {
    return;
  }

  // projection 객체를 통해 LatLng 좌표를 화면 좌표로 변경합니다.
  var projection = this.getProjection();
  var position = this.getPosition();
  var pixelPosition = projection.fromCoordToOffset(position);
  this._element.style.left = pixelPosition.x - 0 + "px";
  this._element.style.top = pixelPosition.y - 0 + "px";
};

CustomOverlay.prototype.onRemove = function () {
  this._element.remove();
  // this._element.off();
};

CustomOverlay.prototype.setPosition = function (position) {
  this._position = position;
  this.draw();
};

CustomOverlay.prototype.getPosition = function () {
  return this._position;
};

export { CustomOverlay };
